module.exports = __webpack_public_path__ + "img/selected1-min.d2281210.png";